import { createAsyncActionType } from 'utils/reduxUtils';

export const ON_CHANGE_LANG = createAsyncActionType('@global/on-change-lang');
export const GET_INIT = createAsyncActionType('@global/get-init');
export const SET_HELP_TIP_STATUS = createAsyncActionType('@global/set-help-tip-status');

export const GET_SUBSCRIPTIONS = createAsyncActionType('@sign-up/get-subscriptions');
export const GET_CURRENT_USER_INIT = createAsyncActionType('@sign-up/get-current-user-init');
export const ON_CHANGE_SIGNUP_FIELD = '@sign-up/on-change-signup-field';
export const GET_SETTINGS = createAsyncActionType('@sign-up/get-settings');
export const CREATE_ACCOUNT = createAsyncActionType('@sign-up/create-account');
export const CREATE_ACCOUNT_FOR_PUBLIC_ORG = createAsyncActionType('@sign-up/create-account-for-public-org');
export const WITHINGEOFENCE = createAsyncActionType('@sign-up/within-geo-fence');
export const GETPRIVATEUSERINFO = createAsyncActionType('@sign-up/get-private-user-info');
export const FETCH_COUNTRIES = createAsyncActionType('@sign-up/fetch-countries');
export const FETCH_PUBLIC_PROFILE = createAsyncActionType('@sign-up/fetch-public-profile');
export const FETCH_LANGUAGE_SETTINGS = createAsyncActionType('@sign-up/fetch-language-settings');

export const FETCH_STATES_AND_COUNTRIES =
  createAsyncActionType('@location/get-states-and-countries');
export const FETCH_GEOCODING_ADDRESSES =
  createAsyncActionType('@location/get-geocoding-addresses');
export const SAVE_GEOCODING_ADDRESS =
  createAsyncActionType('@location/save-geocoding-address');
export const CHECKLOCATIONNAME =
  createAsyncActionType('@location/check-location-name');
export const EDIT_LOCATION = '@location/edit-location';
export const SET_LOCATION = '@location/set-location';
export const VERIFY_LOCATION = '@location/verify-location';
export const OPEN_VIEW_ON_MAP_MODAL = '@location/open-view-on-map-modal';
export const CLOSE_VIEW_ON_MAP_MODAL = '@location/close-view-on-map-modal';
export const SHOW_SUMMARY_LIST = '@location/show-summary-list';
export const HIDE_SUMMARY_LIST = '@location/hide-summary-list';
export const DELETE_SUMMARY_ITEM = '@location/delete-summary-item';

export const ON_UNMOUNT_NOTIFICATION_LIST = '@notification-center/on-unmount-notification-list';
export const ON_UNMOUNT_WEATHER_ALERT_LIST = '@notification-center/on-unmount-weather-alert-list';
export const ON_CLEAR_CACHE = '@notification-center/on-clear-cache';
export const GET_NOTIFICATION_LIST = createAsyncActionType(
  '@notification-center/get-notification-list',
);
export const GET_NOTIFICATION = createAsyncActionType('@notification-center/get-notification');
export const GET_WEATHER_ALERT_LIST = createAsyncActionType(
  '@notification-center/get-weather-alert-list',
);
export const GET_WEATHER_ALERT = createAsyncActionType('@notification-center/get-weather-alert');

export const GET_MY_PROFILE = createAsyncActionType('@current-user/get-my-profile');
export const GET_CONTACT_PATHS = createAsyncActionType('@current-user/get-contact-paths');
export const GET_PROFILE_INIT = createAsyncActionType('@current-user/get-profile-init');

export const SAVE_MY_PROFILE = createAsyncActionType('@edit-profile/save-my-profile');

export const SIDEBAR_TO_MAP_STATE = '@task/map-sidebar-to-map';
export const MAP_PHONE_TO_SUBMIT = createAsyncActionType('@sign-up/get-as-is-state');
export const MAP_PHONESMS_TO_SUBMIT = '@sign-up/get-phone-as-is-state';
export const GET_LOCATION_LIST = createAsyncActionType('@location/get-address-list');
export const SAVE_OR_UPDATE_LOCATION = createAsyncActionType('@location/save-or-update-address');
export const DELETE_LOCATION = createAsyncActionType('@location/delete-address');
export const SAVE_OR_UPDATE_EXPECTED_LOCATION = createAsyncActionType('@location/save-or-update-exp-loc');
export const DELETE_EXP_LOCATION = createAsyncActionType('@location/delete-exp-location');
export const GET_EXPECTED_LOCATION_LIST = createAsyncActionType('@location/get-expected-location-list');

// subscriptions
export const GET_GROUP_SUBSCRIPTION = createAsyncActionType('@subscription/get-group-subscription');
export const GET_ALERT_SUBSCRIPTION = createAsyncActionType('@subscription/get-alert-subscription');
export const GET_INCIDENT_SUBSCRIPTION = createAsyncActionType('@subscription/get-incident-subscription');
export const UPDATE_GROUP_SUBSCRIPTION = createAsyncActionType('@subscription/update-group-subscription');
export const UPDATE_ALERT_SUBSCRIPTION = createAsyncActionType('@subscription/update-alert-subscription');
export const UPDATE_INCIDENT_SUBSCRIPTION = createAsyncActionType('@subscription/update-incident-subscription');
export const CLEAR_SUBSCRIPTION_DATA = createAsyncActionType('@subscription/clear-subscription-data');
export const SET_SHOULD_SHOW_INCIDENT_SUB = '@subscription/set-should-show-incident-sub';
export const CHECK_SHOW_INCIDENT_SUBSCRIPTION = createAsyncActionType('@subscription/check-show-incident-subscription');

// Group Memberships
export const GET_GROUP_MEMBERSHIP = createAsyncActionType('@subscription/get-group-membership');
export const CLEAR_GROUP_MEMBERSHIP_DATA = createAsyncActionType('@subscription/clear-group-membership-data');
export const UPDATE_GROUP_MEMBERSHIP = createAsyncActionType('@subscription/update-group-membership');

// additional information
export const GET_ADDITIONALINFO_LIST = createAsyncActionType('@additionalInformation/get-additional-information');

export const SAVE_ADDITIONALINFO = createAsyncActionType('@additionalInformation/save-additional-information');

// help and answer
export const GET_HELP_AND_ANSWER = createAsyncActionType('@help-and-answer/get-help-and-answer');

// Send Notification
export const HAS_SEND_NOTIFICATION_PERMISSION = createAsyncActionType('@my-profile/has-send-notification-permission');
export const RECAPTCHA_VERIFIED = createAsyncActionType('@my-profile/recaptcha-verified');
export const SEND_TEST_NOTIFICATION = createAsyncActionType('@my-profile/send-test-notification');
